import * as React from 'react';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { blue } from '@material-ui/core/colors/';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import './TableAdmin.css'
import Paper from '@mui/material/Paper';


const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: blue[800],
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));



export default function CustomizedTablesAdmin(props) {
    const products = props

    return (
        <div className="containerTableAdmin">
            <TableContainer component={Paper} >
                <Table >
                    <TableHead>
                        <TableRow>
                            <StyledTableCell align="right">Empresa</StyledTableCell>
                            <StyledTableCell align="right">Nº licenças PID</StyledTableCell>
                            <StyledTableCell align="right">Nº licenças Historian</StyledTableCell>
                            <StyledTableCell align="right">Licença à expirar</StyledTableCell>
                            <StyledTableCell align="right"></StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {products.map((row) => (
                            <StyledTableRow key={row.company}>
                                <StyledTableCell align="right">{row.company}</StyledTableCell>
                                <StyledTableCell align="right">{row.sum_pid}</StyledTableCell>
                                <StyledTableCell align="right">{row.sum_historian}</StyledTableCell>
                                <StyledTableCell align="right">{row.license}</StyledTableCell>
                                <StyledTableCell align="right">
                                    <div>
                                        <IconButton aria-label="delete">
                                            <EditIcon style={{ fontSize: 20 }} />
                                        </IconButton>
                                        <IconButton aria-label="delete">
                                            <DeleteIcon style={{ fontSize: 20 }} />
                                        </IconButton>
                                    </div>
                                </StyledTableCell>
                            </StyledTableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
}